import { connect } from 'react-redux'
import React from 'react'
import { generateUID } from '../../utils/generateUID'
import { postNode } from '../../controllers/treeEngine'
import { startTextEdit, endTextEdit, moveCursorTo, moveCursorToBestChildOrSelf } from '../../store/cursor'

const ListItemChildrenButtonComponent = (props) => {
    const onClickPlus = () => {
        const { node } = props
        if (node.text === '') return
        const newNode = {}
        if (node) {
            newNode.parentId = node.id
        }
        if (node.type === 'text') {
            newNode.type = node.type
        }
        newNode.id = generateUID()

        postNode(newNode)
        props.moveCursorTo(newNode.id)
        props.startTextEdit()
    }

    const onClickChildren = () => {
        props.moveCursorToBestChildOrSelf(props.nodeId)
        props.endTextEdit()
    }

    if (props.childrenLength > 0) {
        return (
            <button onClick={onClickChildren} className="list-item-children-button">
                <i className="far fa-chevron-right"></i>
            </button>
        )
    } else {
        return (
            <button onClick={onClickPlus} className="list-item-children-button">
                <i className="fal fa-plus"></i>
            </button>
        )
    }
}

const mapDispatchToProps = {
    moveCursorToBestChildOrSelf,
    moveCursorTo,
    startTextEdit,
    endTextEdit
}

const mapStateToProps = (state, ownProps) => {
    // Using manual selecting because selectors we have are heavier
    return {
        childrenLength: state.nodes[ownProps.nodeId].childrenIds.length,
        node: state.nodes[ownProps.nodeId]
    }
}

export const ListItemChildrenButton = connect(mapStateToProps, mapDispatchToProps)(ListItemChildrenButtonComponent)
